<template lang='pug'>
v-expansion-panels(
    focusable
    class="pt-6"
)
    v-expansion-panel(
      v-for="(item,i) in data"
      :key="i"
    )
      v-expansion-panel-header {{ item.question }}
      v-expansion-panel-content
        div(
            class="mt-2" 
            v-html="item.answer"
        )
    
</template>

<script>
export default {
  name: "FaqUsers",
  props: {
    data: Array,
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>